export default "__VITE_ASSET__CTQMwz42__"